module.exports = __webpack_public_path__ + "img/co.0ebe070b.svg";